export type StatusTone = 'neutral' | 'success' | 'warning' | 'error' | 'accent' | 'confirm';

/** Цвет точки статуса; нужен и тем, кто рисует точку без пилюли. */
export const STATUS_DOT_CLASSES: Record<StatusTone, string> = {
  neutral: 'bg-(--text-secondary)',
  success: 'bg-(--success)',
  warning: 'bg-(--warning)',
  error: 'bg-(--danger)',
  accent: 'bg-(--accent)',
  confirm: 'bg-(--info)',
};
